import { QuotesCodeMapping } from '@/constants/quote/quote';
import { formatTime } from '@/utils/time';
import { type CellContext } from '@tanstack/react-table';

export const timeColumn = {
  accessorKey: QuotesCodeMapping.TRADE_TIME.toString(),
  header: () => <div className='text-left'>時間</div>,
  size: 40,
  cell: (props: CellContext<unknown, number>) => {
    const timestamp = props.getValue();

    return (
      <time className='inline-block w-full text-left text-xs text-[#777777]' suppressHydrationWarning>
        {timestamp ? formatTime(timestamp, 'HHMM') : '--'}
      </time>
    );
  },
  enableSorting: false
};
